// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-custom[data-v-1f25b2c2]{height:150px;background-position:50%;background-size:contain}", ""]);
// Exports
module.exports = exports;
